import { TableHead } from '@/components/Datatable/TableHead';
import { SortableTableHeadersProps } from '@/type/listing.types';
import { USER_TIPS } from '@/docs/tips/users';

export const UserTableHeaders = ({ t, onSort }: SortableTableHeadersProps) => {
  return (
    <>
      <TableHead
        text={t('common:users')}
        thClassName="min-w-[300px]"
        sortable
        onSortClick={() => onSort?.('userFullName')}
      />
      <TableHead
        text={t('common:status')}
        thClassName="text-center min-w-0 w-0"
        infoTip={USER_TIPS.statusColumn}
      />
      <TableHead
        text={t('common:groups')}
        thClassName="min-w-[200px]"
        infoTip={USER_TIPS.groupsColumn}
      />
      <TableHead
        text={t('common:email')}
        thClassName="min-w-[230px]"
        sortable
        onSortClick={() => onSort?.('userEmail')}
      />
      <TableHead
        text={t('common:inspections')}
        thClassName="min-w-0 w-0"
        infoTip={USER_TIPS.inspectionsColumn}
      />
      <TableHead thClassName="sticky-action-column" />
    </>
  );
};
